import PurchaseOrderViewListDrawer from './PurchaseOrderViewListDrawerContainer';

export default PurchaseOrderViewListDrawer;
